var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user"},[_c('v-img',{staticClass:"avatar",attrs:{"src":_setup.getAvatar(_vm.user.avatar, 200)}}),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.user.dancerName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }